// startup
// Load entry module
__webpack_require__("./admin/assets/js/settings.js");
// This entry module used 'exports' so it can't be inlined
